"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jobBankExperienceRequirement = exports.jobBankEducationRequirement = exports.jobBankHoursOfWork = exports.jobBankStartDateType = exports.jobBankPeriodOfEmployment = exports.jobBankWorkplaceInformation = exports.jobBankWhoCanApply = exports.jobBankJobType = exports.lmiaPortalTransitionPlanExemptionTypes = exports.lmiaPortalMonths = exports.lmiaPortalCaregiverLiveArrangementVoluntary = exports.lmiaPortalCaregiverLanguageCorrespondence = exports.lmiaPortalCaregiverAlternatePhone = exports.lmiaPortalSupportTFW = exports.lmiaPortalOffFarmHousingSkilled = exports.lmiaPortalOffFarmOnFarmHousing = exports.lmiaPortalAgricultureCropMethodHarvest = exports.lmiaPortalAgricultureCropType = exports.lmiaPortalSAWPArrivalType = exports.lmiaPortalGtsCategoryBOccupation = exports.lmiaPortalDesignatedReferralPartner = exports.lmiaPortalGtsCategory = exports.lmiaPortalEmploymentDurationType = exports.lmiaPortalLanguageCommunicate = exports.lmiaPortalLanguageCommunicateType = exports.lmiaPortalOvertimeDetermined = exports.jobBankSizeOfBusiness = exports.jobBankTypeOfBusiness = exports.jobBankIndustry = exports.maritalStatusesParentChildrenSiblingsFamilyInformation = exports.maritalStatusesApplicantSpouseFamilyInformation = exports.usaStates = exports.workPermitTypeInsideCanada = exports.workPermitType = exports.purposeOfVisitComingToCanada = exports.purposeOfVisit = exports.legalRepresentativeOrganization = exports.studyFundsPaidBy = exports.fieldOfStudy = exports.levelOfStudy = exports.canadianProvinces = exports.canadianLangOptions = exports.langCommunicateCanadaTransformed = exports.allLanguages = exports.countryCitizenship = exports.countryResidenceOptionsTransformed = exports.maritalStatusPreviousTransformed = exports.maritalStatus = exports.residenceStatusOptionsTransformed = exports.genderOptionsTransformed = void 0;
exports.jobBankScreeningOptions = exports.jobBankApplyInstructions = exports.jobBankPersonalSuitability = exports.jobBankWorkConditionsPhysical = exports.jobBankTransportationTravel = exports.jobBankSecuritySafety = exports.jobBankAreaSpecialization = exports.jobBankComputerTechKnowledge = exports.jobBankSupervision = exports.jobBankTasks = exports.jobBankBudgetaryResponsibility = exports.jobBankWorkSetting = exports.jobBankGreenJob = exports.jobBankOtherBenefits = exports.jobBankLongTermBenefits = exports.jobBankFinancialBenefits = exports.jobBankHealthBenefits = exports.jobBankEmploymentTermOptions = exports.jobBankTargetGroups = exports.lmiaPortalCaregiverBedroomFeatures = exports.lmiaPortalMinimumEducationRequirements = exports.greenInitiatives = exports.workplaceAmenities = exports.workplaceAccommodations = exports.learningOpportunities = exports.siblingRelationship = exports.telephoneNumberType = exports.educationRequirementsOther = exports.talentBenefits = exports.companyBusinessActivities = exports.companyOrganizationType = exports.partnerOccupation = exports.bringingPartner = exports.canadianStatus = exports.yesNoOptions = exports.highestLevelEducationCompleted = exports.primaryWorkExperienceSector = exports.yearsOfWorkExperience = exports.jobBankLanguageRequirement = void 0;
const static_1 = require("../static");
const communicate_en_fr_1 = require("../static/communicate-en-fr");
const communicate_main_en_fr_1 = require("../static/communicate-main-en-fr");
const countries_1 = require("../static/countries");
const field_of_study_1 = require("../static/field-of-study");
const genders_1 = require("../static/genders");
const level_of_study_1 = require("../static/level-of-study");
const marital_status_previous_1 = require("../static/marital-status-previous");
const marital_statuses_1 = require("../static/marital-statuses");
const native_languages_1 = require("../static/native-languages");
const professional_rep_category_1 = require("../static/professional-rep-category");
const provinces_1 = require("../static/provinces");
const purpose_of_visit_1 = require("../static/purpose-of-visit");
const residence_statuses_1 = require("../static/residence-statuses");
const study_funds_paid_by_1 = require("../static/study-funds-paid-by");
const usa_states_1 = require("../static/usa-states");
const formatOptions = (options) => {
    return options.map((option) => {
        return {
            option,
        };
    });
};
const formatOptionsWithId = (options) => {
    return options.map((option) => {
        return {
            option: option.value,
            label: option.id,
        };
    });
};
const formatOptionsLabel = (options) => {
    return options.map((option) => {
        return {
            option: option.label,
        };
    });
};
/**********************
 * OPTIONS WITH VALUE *
 **********************/
exports.genderOptionsTransformed = formatOptionsLabel(genders_1.gendersList);
exports.residenceStatusOptionsTransformed = formatOptionsLabel(residence_statuses_1.residenceStatusesList);
exports.maritalStatus = formatOptionsLabel(marital_statuses_1.maritalStatusesList);
exports.maritalStatusPreviousTransformed = formatOptionsLabel(marital_status_previous_1.maritalStatusPreviousList);
exports.countryResidenceOptionsTransformed = formatOptionsLabel(countries_1.countryResidenceList);
exports.countryCitizenship = formatOptionsLabel(countries_1.countryCitizenshipList);
exports.allLanguages = formatOptionsLabel(native_languages_1.nativeLanguagesList);
exports.langCommunicateCanadaTransformed = formatOptionsLabel(communicate_en_fr_1.communicateEnglishFrenchList);
exports.canadianLangOptions = formatOptionsLabel(communicate_main_en_fr_1.communicateMainEnglishFrenchList);
exports.canadianProvinces = formatOptionsLabel(provinces_1.provincesList);
exports.levelOfStudy = formatOptionsLabel(level_of_study_1.levelOfStudyList);
exports.fieldOfStudy = formatOptionsLabel(field_of_study_1.fieldOfStudyList);
exports.studyFundsPaidBy = formatOptionsLabel(study_funds_paid_by_1.studyFundsPaidByList);
exports.legalRepresentativeOrganization = formatOptionsLabel(professional_rep_category_1.legalRepresentativeOrganizationList);
exports.purposeOfVisit = formatOptionsLabel(purpose_of_visit_1.purposeOfVisitList);
exports.purposeOfVisitComingToCanada = formatOptionsLabel(purpose_of_visit_1.purposeOfVisitComingToCanadaList);
exports.workPermitType = formatOptionsLabel(static_1.workPermitTypeList);
exports.workPermitTypeInsideCanada = formatOptionsLabel(static_1.workPermitTypeInsideCanadaList);
exports.usaStates = formatOptionsLabel(usa_states_1.usaStatesList);
exports.maritalStatusesApplicantSpouseFamilyInformation = formatOptionsLabel(marital_statuses_1.maritalStatusesApplicantSpouseFamilyInformationList);
exports.maritalStatusesParentChildrenSiblingsFamilyInformation = formatOptionsLabel(marital_statuses_1.maritalStatusesParentChildrenSiblingsFamilyInformationList);
// Company General
exports.jobBankIndustry = formatOptionsLabel(static_1.jobBankIndustryValueLabel);
exports.jobBankTypeOfBusiness = formatOptionsLabel(static_1.jobBankTypeOfBusinessValueLabel);
exports.jobBankSizeOfBusiness = formatOptionsLabel(static_1.jobBankSizeOfBusinessValueLabel);
// LMIA Portal
exports.lmiaPortalOvertimeDetermined = formatOptionsLabel(static_1.lmiaPortalOvertimeDeterminedValueLabel);
exports.lmiaPortalLanguageCommunicateType = formatOptionsLabel(static_1.lmiaPortalLanguageCommunicateTypeValueLabel);
exports.lmiaPortalLanguageCommunicate = formatOptionsLabel(static_1.lmiaPortalLanguageCommunicateValueLabel);
exports.lmiaPortalEmploymentDurationType = formatOptionsLabel(static_1.lmiaPortalEmploymentDurationTypeValueLabel);
exports.lmiaPortalGtsCategory = formatOptionsLabel(static_1.lmiaPortalGtsCategoryValueLabel);
exports.lmiaPortalDesignatedReferralPartner = formatOptionsLabel(static_1.lmiaPortalDesignatedReferralPartnerValueLabel);
exports.lmiaPortalGtsCategoryBOccupation = formatOptionsLabel(static_1.lmiaPortalGtsCategoryBOccupationValueLabel);
exports.lmiaPortalSAWPArrivalType = formatOptionsLabel(static_1.lmiaPortalSAWPArrivalTypeValueLabel);
exports.lmiaPortalAgricultureCropType = formatOptionsLabel(static_1.lmiaPortalAgricultureCropTypeValueLabel);
exports.lmiaPortalAgricultureCropMethodHarvest = formatOptionsLabel(static_1.lmiaPortalAgricultureCropMethodHarvestValueLabel);
exports.lmiaPortalOffFarmOnFarmHousing = formatOptionsLabel(static_1.lmiaPortalOffFarmOnFarmHousingValueLabel);
exports.lmiaPortalOffFarmHousingSkilled = formatOptionsLabel(static_1.lmiaPortalOffFarmHousingSkilledValueLabel);
exports.lmiaPortalSupportTFW = formatOptionsLabel(static_1.lmiaPortalSupportTFWValueLabel);
exports.lmiaPortalCaregiverAlternatePhone = formatOptionsLabel(static_1.lmiaPortalCaregiverAlternatePhoneValueLabel);
exports.lmiaPortalCaregiverLanguageCorrespondence = formatOptionsLabel(static_1.lmiaPortalCaregiverLanguageCorrespondenceValueLabel);
exports.lmiaPortalCaregiverLiveArrangementVoluntary = formatOptionsLabel(static_1.lmiaPortalCaregiverLiveArrangementVoluntaryValueLabel);
exports.lmiaPortalMonths = formatOptionsLabel(static_1.lmiaPortalMonthsValueLabel);
exports.lmiaPortalTransitionPlanExemptionTypes = formatOptionsLabel(static_1.lmiaPortalTransitionPlanExemptionTypesValueLabel);
exports.jobBankJobType = formatOptionsLabel(static_1.jobBankJobTypeValueLabel);
exports.jobBankWhoCanApply = formatOptionsLabel(static_1.jobBankWhoCanApplyValueLabel);
exports.jobBankWorkplaceInformation = formatOptionsLabel(static_1.jobBankWorkplaceInformationValueLabel);
exports.jobBankPeriodOfEmployment = formatOptionsLabel(static_1.jobBankPeriodOfEmploymentValueLabel);
exports.jobBankStartDateType = formatOptionsLabel(static_1.jobBankStartDateTypeValueLabel);
exports.jobBankHoursOfWork = formatOptionsLabel(static_1.jobBankHoursOfWorkValueLabel);
exports.jobBankEducationRequirement = formatOptionsLabel(static_1.jobBankEducationRequirementValueLabel);
exports.jobBankExperienceRequirement = formatOptionsLabel(static_1.jobBankExperienceRequirementValueLabel);
exports.jobBankLanguageRequirement = formatOptionsLabel(static_1.jobBankLanguageRequirementValueLabel);
exports.yearsOfWorkExperience = [
    {
        option: "None",
    },
    {
        option: "Less than 1 year",
    },
    {
        option: "1",
    },
    {
        option: "2",
    },
    {
        option: "3",
    },
    {
        option: "4",
    },
    {
        option: "5+",
    },
];
exports.primaryWorkExperienceSector = [
    { option: "IT/software/tech" },
    { option: "Hospitality" },
    { option: "Sales" },
    { option: "Marketing" },
    { option: "Finance" },
    { option: "Operations" },
    { option: "Legal" },
    { option: "Medicine/healthcare" },
    { option: "Food and beverage" },
    { option: "Skilled trades" },
    { option: "Trucking" },
    { option: "Agriculture/farming" },
    { option: "Student" },
    { option: "Unemployed" },
    { option: "Other" },
];
exports.highestLevelEducationCompleted = [
    { option: "None or less than secondary school (high school)" },
    { option: "Secondary diploma (high school graduate)" },
    {
        option: "One-year degree, diploma or certificate from  a university, college, trade or technical school, or other institute",
    },
    {
        option: "Two-year program at a university, college, trade or technical school, or other institute",
    },
    {
        option: "Bachelor's degree OR a three or more year program at a university, college, trade or technical school, or other institute",
    },
    {
        option: "Two or more certificates, diplomas, or degrees. One must be for a program of three or more years",
    },
    {
        option: "Master's degree OR professional degree needed to practice in a licensed profession (i.e. medicine or law)",
    },
    { option: "Doctoral level university degree (Ph.D.)" },
];
/*************************
 * OPTIONS WITHOUT VALUE *
 *************************/
exports.yesNoOptions = formatOptions(["Yes", "No"]);
exports.canadianStatus = formatOptions([
    "Canadian Citizen",
    "Permanent Resident",
]);
exports.bringingPartner = formatOptions([
    "Yes, my spouse",
    "Yes, my common-law partner",
    "No",
]);
exports.partnerOccupation = formatOptions([
    "Working",
    "Studying",
    "None of the above",
]);
exports.companyOrganizationType = formatOptions([
    "Partnership",
    "Incorporated",
    "Sole Proprietorship",
    "Co-Operative",
    "Non-Profit",
    "Registered Charity",
]);
exports.companyBusinessActivities = formatOptionsWithId([
    { value: "Hiring more Canadian citizens/permanent residents", id: "BA_1" },
    {
        value: "Creating partnerships with Canadian colleges/universities for training",
        id: "BA_2",
    },
    {
        value: "Providing paid co-op opportunities to Canadian/permanent resident students",
        id: "BA_3",
    },
    {
        value: "Creating initiatives that increase the participation of underrepresented groups in the workplace",
        id: "BA_4",
    },
    {
        value: "Providing training to Canadians/PRs (training budget for courses, events, etc.)",
        id: "BA_5",
    },
    {
        value: "Ensure your foreign workers will mentor/train current employees for knowledge transfer",
        id: "BA_6",
    },
    {
        value: "Increasing growth of revenue, employment or investment at the firm",
        id: "BA_7",
    },
    {
        value: "Developing or improving best company practices or policies related to attraction/retention of Canadian workforce (for example, by supporting code sprints and hackathons to hire new employees)",
        id: "BA_8",
    },
    {
        value: "Developing or enhancing partnerships with organizations that assist with the identification of top domestic capital",
        id: "BA_9",
    },
]);
exports.talentBenefits = formatOptionsWithId([
    { value: "Disability insurance", id: "BEN_1" },
    { value: "Dental insurance", id: "BEN_2" },
    { value: "Pension", id: "BEN_3" },
    {
        value: "Extended medical insurance (prescription drugs, paramedical services, medical services and equipment)",
        id: "BEN_4",
    },
    { value: "Other", id: "BEN_5" },
]);
exports.educationRequirementsOther = formatOptions([
    "None",
    "Bachelor's",
    "College diploma or certificate",
    "Master's",
    "Doctorate or PhD",
    "Other (please explain)",
]);
exports.telephoneNumberType = formatOptions([
    "Residence",
    "Cellular",
    "Business",
]);
exports.siblingRelationship = formatOptions([
    "Brother (biological)",
    "Sister (biological)",
    "Half-brother",
    "Half-sister",
    "Step-brother",
    "Step-sister",
]);
exports.learningOpportunities = formatOptionsWithId([
    { value: "On-the-job training", id: "CG_LO_1" },
    { value: "Mentorship programs", id: "CG_LO_2" },
    { value: "Scholarships", id: "CG_LO_3" },
    { value: "Team building activities", id: "CG_LO_4" },
    { value: "Leadership training", id: "CG_LO_5" },
    { value: "Career development opportunities", id: "CG_LO_6" },
]);
exports.workplaceAccommodations = formatOptionsWithId([
    { value: "Accessible parking", id: "CG_WA_1" },
    {
        value: "Physical accessibility accommodations (ramps, elevators, etc.)",
        id: "CG_WA_2",
    },
    {
        value: "Visual accessibility accommodations (braille, screen readers, etc.)",
        id: "CG_WA_3",
    },
    {
        value: "Auditory accessibility accommodations (transcription software, teletypewriters, etc.)",
        id: "CG_WA_4",
    },
    { value: "Gentle or low lighting available", id: "CG_WA_5" },
    { value: "Enclosed focus spaces available", id: "CG_WA_6" },
    { value: "Mental health resources available", id: "CG_WA_7" },
    { value: "Variable work hours offered", id: "CG_WA_8" },
    { value: "Reduced work hours offered", id: "CG_WA_9" },
]);
exports.workplaceAmenities = formatOptionsWithId([
    { value: "On-site daycare available", id: "CG_WAM_1" },
    { value: "Gender neutral facilities", id: "CG_WAM_2" },
    { value: "Fitness area", id: "CG_WAM_3" },
    { value: "Breakout spaces", id: "CG_WAM_4" },
    { value: "Collaborative spaces", id: "CG_WAM_5" },
    { value: "Gaming rooms", id: "CG_WAM_6" },
    { value: "Outdoor footpath", id: "CG_WAM_7" },
    { value: "Indoor walkway", id: "CG_WAM_8" },
    { value: "On-site food and beverages", id: "CG_WAM_9" },
    {
        value: "Spaces to socialize (e.g., coffee bars, lounge, etc.)",
        id: "CG_WAM_10",
    },
    { value: "Childcare Services", id: "CG_WAM_11" },
    { value: "Mental health support", id: "CG_WAM_12" },
    {
        value: "Sustainable transportation incentives (e.g., free indoor bicycle parking, free monthly public transit passes, etc.)",
        id: "CG_WAM_13",
    },
    {
        value: "Floating holiday(s)",
        id: "CG_WAM_14",
    },
]);
exports.greenInitiatives = formatOptionsWithId([
    { value: "Waste diversion from landfill", id: "CG_GA_1" },
    { value: "Composting and recycling", id: "CG_GA_2" },
    { value: "Waste water reduction", id: "CG_GA_3" },
    { value: "Energy consumption reduction", id: "CG_GA_4" },
    {
        value: "Use of environmentally friendly products or services",
        id: "CG_GA_5",
    },
    {
        value: "Participation in a government environmental program",
        id: "CG_GA_6",
    },
    { value: "Use of clean technology in the operations", id: "CG_GA_7" },
    {
        value: "Employee discounts for environmentally friendly purchases",
        id: "CG_GA_8",
    },
    {
        value: "Training for employees on environmental sustainability",
        id: "CG_GA_9",
    },
]);
exports.lmiaPortalMinimumEducationRequirements = formatOptionsWithId(static_1.lmiaPortalMinimumEducationRequirementsValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
exports.lmiaPortalCaregiverBedroomFeatures = formatOptionsWithId(static_1.lmiaPortalCaregiverBedroomFeaturesValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
exports.jobBankTargetGroups = formatOptionsWithId(static_1.jobBankTargetGroupsValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
exports.jobBankEmploymentTermOptions = formatOptionsWithId(static_1.jobBankEmploymentTermOptionsValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
exports.jobBankHealthBenefits = formatOptionsWithId(static_1.jobBankHealthBenefitsValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
exports.jobBankFinancialBenefits = formatOptionsWithId(static_1.jobBankFinancialBenefitsValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
exports.jobBankLongTermBenefits = formatOptionsWithId(static_1.jobBankLongTermBenefitsValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
exports.jobBankOtherBenefits = formatOptionsWithId(static_1.jobBankOtherBenefitsValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
exports.jobBankGreenJob = formatOptionsWithId(static_1.jobBankGreenJobValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
exports.jobBankWorkSetting = formatOptionsWithId(static_1.jobBankWorkSettingValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
exports.jobBankBudgetaryResponsibility = formatOptionsWithId(static_1.jobBankBudgetaryResponsibilityValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
exports.jobBankTasks = formatOptionsWithId(static_1.jobBankTasksValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
exports.jobBankSupervision = formatOptionsWithId(static_1.jobBankSupervisionValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
exports.jobBankComputerTechKnowledge = formatOptionsWithId(static_1.jobBankComputerTechKnowledgeValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
exports.jobBankAreaSpecialization = formatOptionsWithId(static_1.jobBankAreaSpecializationValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
exports.jobBankSecuritySafety = formatOptionsWithId(static_1.jobBankSecuritySafetyValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
exports.jobBankTransportationTravel = formatOptionsWithId(static_1.jobBankTransportationTravelValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
exports.jobBankWorkConditionsPhysical = formatOptionsWithId(static_1.jobBankWorkConditionsPhysicalValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
exports.jobBankPersonalSuitability = formatOptionsWithId(static_1.jobBankPersonalSuitabilityValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
exports.jobBankApplyInstructions = formatOptionsWithId(static_1.jobBankApplyInstructionsValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
exports.jobBankScreeningOptions = formatOptionsWithId(static_1.jobBankScreeningOptionsValueLabel.map((option) => ({
    value: option.label,
    id: option.id,
})));
